import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { OverclaimAmendmentModel, OverclaimViewModel } from '@Entities/overclaim/overclaim-view'
import { OverclaimFilterCount } from '@Entities/overclaim/overclaim-status-count'
import { OverclaimHistory } from '@Entities/overclaim/overclaim-history'
import { OverclaimBulkRelinquishment } from '@Entities/overclaim/overclaim-bulk-relinquishment'
import { WorkModel } from '@Entities/work/work'
export {
    attachExistingOverclaimDocument,
    generateBulkOverclaimDocumentUploadUrl,
    generateOverclaimDocumentUploadUrl,
    getAllOverclaimUploadedDocumentsFor,
    getOverclaimUploadDocumentFor,
    searchOverclaimDocuments,
    updateOverclaimDocumentDescription,
} from './overclaim-documents'

export const getOverclaimViewItemByOverclaimHeaderId = (
    overclaimHeaderId: number,
    rightsholderId: number
): Promise<AxiosResponse<OverclaimViewModel>> =>
    axiosClient.get<OverclaimViewModel>(Pathes.RightsHolder.overclaimViewByHeaderId(overclaimHeaderId, rightsholderId))
export const getOverclaimHistoryByOverclaimHeaderId = (
    overclaimHeaderId: number,
    rightsholderId: number
): Promise<AxiosResponse<OverclaimHistory[]>> =>
    axiosClient.get<OverclaimHistory[]>(
        Pathes.RightsHolder.overclaimHistoryByHeaderId(overclaimHeaderId, rightsholderId)
    )
export const getOverclaimStatusCounts = (rightsholderId: number): Promise<AxiosResponse<OverclaimFilterCount>> =>
    axiosClient.get<OverclaimFilterCount>(Pathes.RightsHolder.overclaimStatusCounts(rightsholderId))

export const sendEmail = (overclaimHeaderId: number, rightsholderId: number, content: string): Promise<void> =>
    axiosClient.post(Pathes.RightsHolder.sendOverclaimEmail(overclaimHeaderId, rightsholderId), {
        messageContent: content,
    })
export const renderOverclaimEmailTemplate = (overclaimHeaderId: number, rightsholderId: number) =>
    axiosClient.get<string>(Pathes.RightsHolder.renderOverclaimEmailTemplate(overclaimHeaderId, rightsholderId))
export const amendOverclaimShares = (
    overclaimHeaderId: number,
    rightsholderId: number,
    submission: OverclaimAmendmentModel
) => axiosClient.post(Pathes.RightsHolder.amendOverclaimShares(overclaimHeaderId, rightsholderId), submission)
export const bulkAmendOverclaimShares = (
    overclaimHeaderIds: number[],
    rightsholderId: number,
    overclaimViewDtos: WorkModel[]
) =>
    axiosClient.post(Pathes.RightsHolder.bulkAmendOverclaimShares(rightsholderId), {
        overclaimHeaderIds,
        overclaimViewDtos,
    })
export const createOverclaimRelinquishment = (rightsholderId: number, overclaimHeaderId: number) =>
    axiosClient.post(Pathes.RightsHolder.createRelinquishment(rightsholderId, overclaimHeaderId))
export const createBulkOverclaimRelinquishment = (rightsholderId: number, overclaimHeaderIds: number[]) =>
    axiosClient.post<OverclaimBulkRelinquishment>(
        Pathes.RightsHolder.createBulkRelinquishment(rightsholderId),
        overclaimHeaderIds
    )

export const getRelinquishmentsForOverclaim = (rightsholderId: number, overclaimHeaderId: number) =>
    axiosClient.get(Pathes.RightsHolder.getRelinquishments(rightsholderId, overclaimHeaderId))
